module.exports = __webpack_public_path__ + "img/maskot_maintenance_w-300.35b0fabf.png";